/**
 * Version management API service
 */
import api from './api';

export const versionApi = {
  getVersionHistory: async (documentId) => {
    const response = await api.get(`/documents/${documentId}/versions`);
    return response.data;
  },

  getVersion: async (documentId, versionId) => {
    const response = await api.get(`/documents/${documentId}/versions/${versionId}`);
    return response.data;
  },

  createVersion: async (documentId, file, changeSummary = null) => {
    const formData = new FormData();
    formData.append('file', file);
    if (changeSummary) {
      formData.append('change_summary', changeSummary);
    }
    const response = await api.post(`/documents/${documentId}/versions`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  restoreVersion: async (documentId, versionId) => {
    const response = await api.post(`/documents/${documentId}/versions/${versionId}/restore`);
    return response.data;
  },

  compareVersions: async (documentId, versionId1, versionId2) => {
    const response = await api.get(`/documents/${documentId}/versions/compare`, {
      params: {
        version_id_1: versionId1,
        version_id_2: versionId2,
      },
    });
    return response.data;
  },

  downloadVersion: async (documentId, versionId) => {
    const response = await api.get(`/documents/${documentId}/versions/${versionId}/download`, {
      responseType: 'blob',
    });
    return response;
  },

  deleteVersion: async (documentId, versionId) => {
    await api.delete(`/documents/${documentId}/versions/${versionId}`);
  },
};

export default versionApi;
